<ng-container [ngSwitch]="column.type">
  <span *ngSwitchDefault>
    <ng-container *ngIf="!column.isHtml">
      <span class="mat-cell-text">{{ column.cell(element) }}</span>
    </ng-container>
    <ng-container *ngIf="column.isHtml">
      <span
        class="mat-cell-text"
        [innerHTML]="sanitizeHtml(column.cell(element))"
        (click)="handleHtmlClick($event, column.columnDef, element)"
        [style.width.px]="column.width">
      </span>
    </ng-container>
  </span>

  <span *ngSwitchCase="'ACTIONS'">
    <button mat-icon-button [matMenuTriggerFor]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let action of getActionsForElement(element)"
        (click)="handleActionClick(action.action, element)">
        {{ action.label }}
      </button>
    </mat-menu>
  </span>
</ng-container>
